import * as React from 'react'
import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";
import { ITwoValueWidgetProps } from './TwoValueWidgetProperty';

// The presets (seed values + swatch previews) were moved out of the render
// component so metadata can register eagerly while the render code (XPR)
// code-splits into its own tpl-two-value-widget chunk. DefaultChartProperties is
// duplicated here (the render component keeps its own copy) so `seed` resolves
// without importing from the now-lazy view module.
let DefaultChartProperties: ITwoValueWidgetProps = {
    refreshInterval: 60000,
    channel: '',
    firstValueField: '',
    secondValueField: '',
    firstColor: '#364E7F',
    secondColor: '#F8DE80',
    circleColor: 'black',
    circleIconColor: 'white',
    circleIcon: '',
    secondValueIsTotal: false,
    firstValueLabel: 'Occupied',
    secondValueLabel: 'Unoccupied',
    firstValueLabelColor: '#FFF',
    secondValueLabelColor: '#FFF',

};

interface IWidgetTheme {
    firstColor: string;
    secondColor: string;
    circleColor: string;
}
let Themes: IWidgetTheme[] = [
    {
        firstColor: '#2f4f83',
        circleColor: 'black',
        secondColor: '#F8DE80',
    },
    {
        firstColor: '#8AD4F9',
        circleColor: 'white',
        secondColor: 'black',
    },

    {
        firstColor: '#75CB99',
        circleColor: 'white',
        secondColor: 'black',
    },
    {
        firstColor: "#F7C644",
        secondColor: "#EE9653",
        circleColor: "black",
    },
    {
        firstColor: "#E76965",
        secondColor: "#75CB99",
        circleColor: "black",
    }
];
// v4's theme picker seeded chartProperty with the defaults before merging the
// theme colors — `seed` reproduces that (applied only when absent). The swatch
// is the v4 mini preview: split card with the centered circle (onRender parity).
const Presets = Themes.map((t, i) => ({
    id: `theme-${i}`,
    name: `Theme ${i + 1}`,
    seed: { chartProperty: DefaultChartProperties },
    uiProps: { chartProperty: { ...t } },
    renderSwatch: () => (
        <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex' }}>
            <div style={{ flex: 1, backgroundColor: t.firstColor }} />
            <div style={{ flex: 1, backgroundColor: t.secondColor }} />
            <div
                style={{
                    position: 'absolute',
                    left: '50%',
                    top: '50%',
                    width: '1rem',
                    height: '1rem',
                    borderRadius: '100%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: t.circleColor,
                }}
            />
        </div>
    ),
}));

registerCardTemplate({
    id: 'two-value-widget',
    name: 'Percentage Widget',
    description: 'This widget visualizes two complementary values that combine to make a total. Like occupancy.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-two-value-widget" */ "./TwoValueWidgetTemplate")),
    presets: Presets,
    icon: generateIconProp('tachometerAlt'),
    complexity: 'easy',
    preLoader: 'donut-chart'
});
